import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=2ec88fe8&scoped=true&"
import script from "./EditIcon.vue?vue&type=script&lang=js&"
export * from "./EditIcon.vue?vue&type=script&lang=js&"
import style0 from "./EditIcon.vue?vue&type=style&index=0&id=2ec88fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec88fe8",
  null
  
)

export default component.exports